module.exports = __webpack_public_path__ + "img/icon_start.d6af216e.svg";